import React from 'react';
import PropTypes from "prop-types";

import {LoadingOverlay} from "../LoadingOverlay";

import MobileStepper from "@mui/material/MobileStepper";
import Slide from "@mui/material/Slide";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";

import useTheme from "@mui/material/styles/useTheme";

import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import CloseIcon from '@mui/icons-material/Close';


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ResponsiveStepperDialog = props => {
    const {
        title,
        isOpen,
        isSaving,
        activeStep,
        steps,
        enableSubmit,
        onClose,
        onBack,
        onSubmit,
        children,
        disableBackdropClose,
        noValidate
    } = props;

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const isFirstStep = activeStep === 0;
    const isLastStep = activeStep === steps.length - 1;

    const nextLabel = "Avanti";
    const backLabel = "Indietro";
    const saveLabel = "Salva";
    const cancelLabel = "Cancella";

    const handleClose = (object, reason) => {
        if (disableBackdropClose && reason === "backdropClick") {
            return;
        }

        if (isSaving) {
            return;
        }
        onClose();
    };

    return (
        <Dialog
            fullScreen={isMobile}
            fullWidth={true}
            maxWidth="md"
            TransitionComponent={Transition}
            open={isOpen}
            onClose={handleClose}
            aria-labelledby={title}>


            <form onSubmit={onSubmit}
                  noValidate={noValidate}
                  style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column"
                  }}>
                {
                    // TITLE
                    isMobile ? (
                        <AppBar position="relative">
                            <Toolbar>
                                <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                                    <CloseIcon/>
                                </IconButton>
                                <Typography variant="h6" sx={{ml:2, flexGrow: 1}}>
                                    {title}
                                </Typography>
                                <Button autoFocus
                                        color="inherit"
                                        type="submit"
                                        disabled={!isLastStep || !enableSubmit}>
                                    {saveLabel}
                                </Button>
                            </Toolbar>
                        </AppBar>
                    ) : (
                        <React.Fragment>
                            <DialogTitle>{title}</DialogTitle>
                        </React.Fragment>
                    )
                }

                <DialogContent>
                    {
                        !isMobile &&
                        <Stepper activeStep={activeStep} sx={{pt:1, pb:3}}>
                            {steps.map((label) => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    }
                    {children}
                </DialogContent>

                {
                    isMobile ?
                        <MobileStepper
                            variant="dots"
                            steps={steps.length}
                            position="static"
                            activeStep={activeStep}
                            nextButton={
                                <Button size="small"
                                        type="submit"
                                        disabled={isLastStep || !enableSubmit}>
                                    {nextLabel}
                                    <KeyboardArrowRight/>
                                </Button>
                            }
                            backButton={
                                <Button size="small"
                                        type="button"
                                        onClick={onBack}
                                        disabled={isFirstStep}>
                                    <KeyboardArrowLeft/>
                                    {backLabel}
                                </Button>
                            }
                        />
                        :
                        <DialogActions sx={{py:2, px:3}}>
                            <Button sx={{marginRight: "auto"}}
                                    type="button"
                                    onClick={handleClose}>
                                {cancelLabel}
                            </Button>
                            {
                                !isFirstStep &&
                                <Button type="button"
                                        onClick={onBack}>
                                    {backLabel}
                                </Button>
                            }
                            <Button variant="contained"
                                    type="submit"
                                    disabled={!enableSubmit}>
                                {isLastStep ? saveLabel : nextLabel}
                            </Button>
                        </DialogActions>
                }
            </form>
            <LoadingOverlay isLoading={isSaving}/>
        </Dialog>
    )
};

ResponsiveStepperDialog.propTypes = {
    title: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    isSaving: PropTypes.bool.isRequired,
    activeStep: PropTypes.number.isRequired,
    steps: PropTypes.arrayOf(PropTypes.string).isRequired,
    enableSubmit: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    disableBackdropClose: PropTypes.bool,
    noValidate: PropTypes.bool
};

export {ResponsiveStepperDialog}